import { PureComponent } from 'react'
import { connect } from 'react-redux'
import compose from 'recompose/compose'

// Material UI
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Typography from '@material-ui/core/Typography'
import { withStyles, withTheme } from '@material-ui/core/styles'

// Resources
import { Checkbox,Button, FormControlLabel, TableContainer, TablePagination, TextField } from '@material-ui/core'
import { CSVLink } from 'react-csv'
import { withRouter } from 'react-router-dom'
import { requestPaymentsByOfficeId } from '../actions/actions'
import Utils from '../resources/Utils'
import CircleLoading from './CircleLoading'

const styles = theme => ({
  headerTable: {
    fontWeight: 700,
    width: '100%',
    Height: '100px'
  },

  smallCell: {
    margin: 0,
    padding: 0
  },
  emojiAlias: {
    marginRight: 8,
    width: 18
  },
  hidden: {
    display: 'none'
  },
  textField: {
    width: '100%',
    margin: '5px',
    textAlignLast: 'end'
  },
  tableHeader: {
    position: 'sticky',
    top: '0',
  },
  paginationEnd: {
    position: 'sticky',
    bottom: '0',
    with: '100%',

  },
  activeScroll: {
    overflow: 'auto',
  },

})
let data = {
  pageNumber: 1,
  pageSize: 5,
  searchByReference: '',
  searchByAutorization: '',
  initialDate: '',
  finalDate: '',
  isMulti:false
}
class PaymentsTable extends PureComponent {

  constructor(props) {
    super(props)
    this.props.requestPaymentsByOfficeId(data)
    this.state = {
      notIsData: false,
      isloading: false,
      page: 0,
      rowsPerPage: !Utils.isEmpty(this.props.init.payments) && this.props.init.payments.status !== 'WARNING' ? this.props.init.payments.data.pageSize : 5,
      totalPages: !Utils.isEmpty(this.props.init.payments) && this.props.init.payments.status !== 'WARNING' ? this.props.init.payments.data.totalPage : 0,
      data: !Utils.isEmpty(this.props.init.payments) && this.props.init.payments.status !== 'WARNING' ? this.props.init.payments.data.data : [],
      backgroundColor: this.props.init.config.data.appBarColor,
      height: window.innerHeight - 420,
      width: window.innerWidth - 360,
      reference: '',
      autorization: '',
      initialDate: '',
      finalDate: '',
      totalAmount: 0,
      isMultiPays:false
    }
  }
  handleChangePage = (event, newPage) => {
    this.setState({ isloading: true })
    data.pageNumber = newPage + 1
    data.pageSize = this.state.rowsPerPage
    this.props.requestPaymentsByOfficeId(data)
    this.setState({
      page: newPage,
      totalPages: this.state.totalPages,
      data: this.state.data
    });
  };

  componentDidUpdate(prevProps) {
    // Typical usage (don't forget to compare props):
    if (this.props.init.payments !== prevProps.init.payments) {
      if (this.props.init.payments.status === 'WARNING') {
        this.setState({ notIsData: true, page: 0, isloading: false })
      } else {
        const { page, rowsPerPage } = this.state;
        const totalPages = this.props.init.payments.data.totalPage;
        const data = this.props.init.payments.data.data;
        var numPage = page;
        if ((rowsPerPage * page) > totalPages) {
          numPage = Math.round(totalPages / rowsPerPage)
        }
        this.setState({
          notIsData: false,
          isloading: false,
          page: numPage,
          rowsPerPage: rowsPerPage,
          totalPages: totalPages,
          data: data
        })


      }

    }

  }
  handleChangeRowsPerPage = (event) => {
    this.setState({ isloading: true })
    if ((parseInt(event.target.value, 10) * this.state.page) >= this.state.totalPages) {
      for (let i = this.state.page; i >= 0; i--) {
        if ((parseInt(event.target.value, 10) * i) < this.state.totalPages) {
          data.pageNumber = i + 1
          i = 0
        }

      }
    }
    data.pageSize = parseInt(event.target.value, 10)
    this.props.requestPaymentsByOfficeId(data)
    this.setState({
      rowsPerPage: parseInt(event.target.value, 10),
      page: this.state.page >= 1 ? data.pageNumber - 1 : this.state.page,
      totalPages: this.state.totalPages,
      data: this.state.data
    });

  };
  handleChangeSearchPayment = (event) => {
    if (!(Utils.isEmpty(event.target.value) || event.target.value === '')) {
      this.setState({ isloading: true })
      data.searchByReference = event.target.value
      this.props.requestPaymentsByOfficeId(data)
      this.setState({
        isloading: false,
        reference: event.target.value,
        page: 0,
        rowsPerPage: !Utils.isEmpty(this.props.init.payments) && this.props.init.payments.status !== 'WARNING' ? this.props.init.payments.data.pageSize : 5,
        totalPages: !Utils.isEmpty(this.props.init.payments) && this.props.init.payments.status !== 'WARNING' ? this.props.init.payments.data.totalPage : 0,
        data: !Utils.isEmpty(this.props.init.payments) && this.props.init.payments.status !== 'WARNING' ? this.props.init.payments.data.data : []
      });
    } else {
      data.searchByReference = ''
      this.setState({
        reference: ''
      })
      this.props.requestPaymentsByOfficeId(data)
    }
  }
  handleChangeSearchPaymentAutorization = (event) => {
    if (!(Utils.isEmpty(event.target.value) || event.target.value === '')) {
      this.setState({ isloading: true })
      data.searchByAutorization = event.target.value
      this.props.requestPaymentsByOfficeId(data)
      this.setState({
        isloading: false,
        autorization: event.target.value,
        page: 0,
        rowsPerPage: !Utils.isEmpty(this.props.init.payments) && this.props.init.payments.status !== 'WARNING' ? this.props.init.payments.data.pageSize : 5,
        totalPages: !Utils.isEmpty(this.props.init.payments) && this.props.init.payments.status !== 'WARNING' ? this.props.init.payments.data.totalPage : 0,
        data: !Utils.isEmpty(this.props.init.payments) && this.props.init.payments.status !== 'WARNING' ? this.props.init.payments.data.data : []
      });
    } else {
      data.searchByAutorization = ''
      this.setState({
        autorization: ''
      })
      this.props.requestPaymentsByOfficeId(data)
    }
  }
  handleChangeinitialDate = (event) => {
    this.setState({ isloading: true, initialDate: event.target.value })
    data.initialDate = event.target.value;
    if (!Utils.isEmpty(data.initialDate) && !Utils.isEmpty(data.finalDate)) {
      this.props.requestPaymentsByOfficeId(data)
    }
  }
  handleChangefinalDate = (event) => {
    this.setState({ isloading: true, finalDate: event.target.value })
    data.finalDate = event.target.value;
    if (!Utils.isEmpty(data.initialDate) && !Utils.isEmpty(data.finalDate)) {
      this.props.requestPaymentsByOfficeId(data)
    }
  }
  handleTexfieldsClear = () => {
    this.setState({
      reference: '',
      autorization: '',
      initialDate: '',
      finalDate: ''
    })
    data.searchByAutorization = ''
    data.searchByReference = ''
    data.initialDate = ''
    data.finalDate = ''
    this.props.requestPaymentsByOfficeId(data)
  }
  handleChangeMultiPays=(isMultiPays)=>{
    this.setState({
      isMultiPays:!isMultiPays
    })

    if(!isMultiPays){
      data.isMulti=!isMultiPays
      this.props.requestPaymentsByOfficeId(data)
    }else{
      data.isMulti=false
      this.props.requestPaymentsByOfficeId(data)
    }
    
  }
  renderTableData = () => {
    const { data, page, rowsPerPage } = this.state;
    const { classes } = this.props
    const slicedData = data.slice(page * rowsPerPage, (page * rowsPerPage) + rowsPerPage);
    let totalMontos = 0
    data.map((payment) => {
      totalMontos += payment.mp_amount
    })
    return (

      <TableBody>
        {(!Utils.isEmpty(slicedData)) ?
          slicedData.map((payment, idx) => {
            this.setState({ totalAmount: totalMontos.toFixed(2) })
            return (
              <TableRow key={idx} >
                <TableCell><Typography variant="body2" className={classes.smallCell}>{payment.officeId}</Typography></TableCell>
                <TableCell><Typography variant="body2" className={classes.smallCell}>{payment.mp_order}</Typography></TableCell>
                <TableCell><Typography variant="body2" className={classes.smallCell}>{payment.mp_reference}</Typography></TableCell>
                <TableCell><Typography variant="body2" className={classes.smallCell}>{payment.mp_amount}</Typography></TableCell>
                <TableCell><Typography variant="body2" className={classes.smallCell}>{payment.mp_response}</Typography></TableCell>
                <TableCell><Typography variant="body2" className={classes.smallCell}>{payment.mp_authorization}</Typography></TableCell>
                <TableCell><Typography variant="body2" className={classes.smallCell}>{payment.status}</Typography></TableCell>
                <TableCell><Typography variant="body2" className={classes.smallCell}>{payment.description}</Typography></TableCell>
                <TableCell><Typography variant="body2" className={classes.smallCell}>{payment.register_date}</Typography></TableCell>
              </TableRow>
            )
          }) : ''

        }
      </TableBody>
    );
  }
  render() {

    const { classes } = this.props
    const { isMultiPays,page, rowsPerPage, totalPages, backgroundColor, height, width, isloading, notIsData, reference, autorization, initialDate, finalDate, data, totalAmount } = this.state;
    const date = new Date();
    return (
      <div>
        <div style={{ height: '145px', overflowY: 'auto' }}>
          <TableHead>
            <TableRow>
              <TableCell>
                <TextField fullWidth style={{ minWidth: '100px' }} type="text" value={reference} InputLabelProps={{ shrink: true }} defi id="standard-basic" label={Utils.getMessages().paymentsHeaders.reference} onChange={this.handleChangeSearchPayment} />
              </TableCell>
              <TableCell>
                <TextField fullWidth style={{ minWidth: '100px' }} type="text" value={autorization} InputLabelProps={{ shrink: true }} defi id="standard-basic" label={Utils.getMessages().paymentsHeaders.authorization} onChange={this.handleChangeSearchPaymentAutorization} />
              </TableCell>
              <TableCell>
                <TextField fullWidth type="date" value={initialDate} InputLabelProps={{ shrink: true }} inputProps={{ max: date.toISOString().substring(0, 10) }} defi id="standard-basic" label={Utils.getMessages().paymentsMessages.initialDate} onChange={this.handleChangeinitialDate} />
              </TableCell>
              <TableCell>
                <TextField fullWidth type="date" value={finalDate} InputLabelProps={{ shrink: true }} inputProps={{ max: date.toISOString().substring(0, 10) }} defi id="standard-basic" label={Utils.getMessages().paymentsMessages.finalDate} onChange={this.handleChangefinalDate} />
              </TableCell>
              <TableCell>
                <Button variant="contained" color="primary" style={{ width: '100%', height: window.innerHeight * 0.04 }} onClick={this.handleTexfieldsClear} >{Utils.getMessages().paymentsMessages.buttonClear}</Button>
              </TableCell>
              <TableCell>
                <CSVLink data={data} filename={Utils.getMessages().paymentsMessages.title}>
                  <Button variant="contained" color="primary" style={{ width: '100%', height: window.innerHeight * 0.04 }}>
                    {Utils.getMessages().General.exportCSV}
                  </Button>
                </CSVLink>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography variant='body1' className={classes.headerTable}>
                  {Utils.getMessages().paymentsMessages.totalAmount} : {notIsData ? 0 : totalAmount}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant='body1' className={classes.headerTable}>
                  {Utils.getMessages().pagination.rows}: {notIsData ? 0 : rowsPerPage * (page + 1) > totalPages ? totalPages : rowsPerPage * (page + 1)}
                </Typography>
              </TableCell>
              <TableCell>
                <Typography variant='body1' className={classes.headerTable}>
                <FormControlLabel label={Utils.getMessages().paymentsMessages.paysMulti} control={<Checkbox color={backgroundColor} checked={isMultiPays} onChange={()=>this.handleChangeMultiPays(isMultiPays)}/>} />
                </Typography>
              </TableCell>
            </TableRow>
          </TableHead>
        </div>
        {
          (isloading) ? <CircleLoading mensajeCargando="Cargando datos" />
            : (notIsData) ?
              <Typography variant='body1' className={classes.smallCell} style={{ textAlign: 'center' }}>{Utils.getMessages().paymentsMessages.notData}</Typography>
              :
              <TableContainer>
                <div className={classes.activeScroll} style={{ 'height': height < window.innerHeight - 430 ? height : (window.innerHeight - 430) }}>
                  <Table>
                    <TableHead className={classes.tableHeader} style={{ background: backgroundColor }}>
                      <TableRow>
                        <TableCell><Typography variant="body1" className={classes.headerTable}>{Utils.getMessages().paymentsHeaders.officeId}</Typography></TableCell>
                        <TableCell><Typography variant="body1" className={classes.headerTable}>{Utils.getMessages().paymentsHeaders.noOrden}</Typography></TableCell>
                        <TableCell><Typography variant="body1" className={classes.headerTable}>{Utils.getMessages().paymentsHeaders.reference}</Typography></TableCell>
                        <TableCell><Typography variant="body1" className={classes.headerTable}>{Utils.getMessages().paymentsHeaders.amount}</Typography></TableCell>
                        <TableCell><Typography variant="body1" className={classes.headerTable}>{Utils.getMessages().paymentsHeaders.response}</Typography></TableCell>
                        <TableCell><Typography variant="body1" className={classes.headerTable}>{Utils.getMessages().paymentsHeaders.authorization}</Typography></TableCell>
                        <TableCell><Typography variant="body1" className={classes.headerTable}>{Utils.getMessages().paymentsHeaders.status}</Typography></TableCell>
                        <TableCell><Typography variant="body1" className={classes.headerTable}>{Utils.getMessages().paymentsHeaders.description}</Typography></TableCell>
                        <TableCell><Typography variant="body1" className={classes.headerTable}>{Utils.getMessages().paymentsHeaders.registerDate}</Typography></TableCell>
                      </TableRow>
                    </TableHead>

                    {
                      this.renderTableData()
                    }

                  </Table>
                  {(!Utils.isEmpty(this.props.init.payments)) ?
                    <TablePagination
                      className={classes.paginationEnd}
                      style={{ 'background': backgroundColor }}
                      labelRowsPerPage={<Typography variant="body1">{Utils.getMessages().pagination.rowsPerPages}</Typography>}
                      labelDisplayedRows={({ from, to, count }) => <Typography variant="body1">{from} - {to} {Utils.getMessages().pagination.of} {count} {Utils.getMessages().pagination.rows}</Typography>}
                      rowsPerPageOptions={[5, 10, 25, 50, 100]}
                      component="div"
                      rowsPerPage={rowsPerPage}
                      backIconButtonText={Utils.getMessages().pagination.previousPage}
                      nextIconButtonText={Utils.getMessages().pagination.nextPage}
                      count={totalPages}
                      page={page}
                      onChangePage={this.handleChangePage}
                      onChangeRowsPerPage={this.handleChangeRowsPerPage}
                    /> : ''
                  }
                </div>
              </TableContainer>}
      </div>
    )
  }
}

const mapStateToProps = state => ({ ...state })

const mapDispatchToProps = dispatch => {
  return {
    requestPaymentsByOfficeId: (data) => {
      dispatch(requestPaymentsByOfficeId(data))
    },
  }
}

export default compose(
  withRouter,
  withTheme,
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(PaymentsTable)
